import React from "react";
import { useNavigate } from "react-router-dom";
import "./Category.css";

import menImg from "../Assets/Frontend_Assets/man11.jpg";
import womenImg from "../Assets/Frontend_Assets/wm1.jpg";
import kidsImg from "../Assets/Frontend_Assets/kid2.jfif";

const Category = () => {
  const navigate = useNavigate();

  return (
    <div className="category-section">
      
      <div className="category-card" onClick={() => navigate("/men")}>
        <img src={menImg} alt="Men" />
        <div className="category-overlay"></div>
        <div className="category-texts">
          <h2>MEN</h2>
          <p className="mb-n">Classic & Modern Wear</p>
        </div>
      </div>

      <div className="category-card" onClick={() => navigate("/women")}>
        <img src={womenImg} alt="Women" />
        <div className="category-overlay"></div>
        <div className="category-texts">
          <h2>WOMEN</h2>
          <p className="mb-n">Elegant & Stylish Fashion</p>

        </div>
        <p>men</p>
      </div>

      <div className="category-card" onClick={() => navigate("/kids")}>
        <img src={kidsImg} alt="Kids" />
        <div className="category-overlay"></div>
        <div className="category-texts">
          <h2>KIDS</h2>
          <p className="mb-n">Comfort & Fun Styles</p>
        </div>
      </div>

    </div>
  );
};

export default Category;
